/**
 * FERP PDF Left Panel (DRR-079)
 *
 * Tab container for: Thumbnails | Outline | Metadata
 */

import { Tabs, Text } from '@mantine/core';
import { IconPhoto, IconListTree, IconInfoCircle } from '@tabler/icons-react';
import { usePdfSuite } from './PdfSuiteContext';
import { ThumbnailPanel } from './ThumbnailPanel';
import { OutlinePanel } from './OutlinePanel';
import { MetadataPanel } from './MetadataPanel';
import type { LeftPanelTab } from './types';

interface PdfLeftPanelProps {
  pdfDocumentProxy?: unknown;
}

export function PdfLeftPanel({ pdfDocumentProxy }: PdfLeftPanelProps) {
  const { state, dispatch } = usePdfSuite();
  const activeTab = state.leftPanel ?? 'thumbnails';

  return (
    <Tabs
      value={activeTab}
      onChange={(tab) => dispatch({ type: 'SET_LEFT_PANEL', tab: tab as LeftPanelTab })}
      variant="outline"
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      <Tabs.List grow>
        <Tabs.Tab value="thumbnails" leftSection={<IconPhoto size={14} />}>
          <Text size="xs">Pages</Text>
        </Tabs.Tab>
        <Tabs.Tab value="outline" leftSection={<IconListTree size={14} />}>
          <Text size="xs">Outline</Text>
        </Tabs.Tab>
        <Tabs.Tab value="metadata" leftSection={<IconInfoCircle size={14} />}>
          <Text size="xs">Info</Text>
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="thumbnails" style={{ flex: 1, overflow: 'auto' }}>
        <ThumbnailPanel />
      </Tabs.Panel>
      <Tabs.Panel value="outline" style={{ flex: 1, overflow: 'auto' }}>
        <OutlinePanel pdfDocumentProxy={pdfDocumentProxy} />
      </Tabs.Panel>
      <Tabs.Panel value="metadata" style={{ flex: 1, overflow: 'auto' }}>
        <MetadataPanel pdfDocumentProxy={pdfDocumentProxy} />
      </Tabs.Panel>
    </Tabs>
  );
}
